import PropTypes from 'prop-types';
import React from 'react';
import ReactCollapse from 'react-collapse';

import { LocaleService } from '@sm360/widget-commons-core-services';

import { PurchaseMethodsModel } from 'commons-vehicle/PurchaseMethods/index.js';
import ModelYear from 'commons-vehicle/ModelYear/index.js';

import AmountLineItem from 'commons-vehicle/Quote/components/TransactionSummary/AmountLineItem/AmountLineItem.jsx';
import AmountLineItemWithIcon from 'commons-vehicle/Quote/components/TransactionSummary/AmountLineItem/AmountLineItemWithIcon.jsx';

class ProtectionsListing extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showProtectionsDetails: false,
        };

        this.showProtectionsDetails = this.showProtectionsDetails.bind(this);
    }

    showProtectionsDetails() {
        this.setState((prevState) => {
            return { showProtectionsDetails: !prevState.showProtectionsDetails };
        });
    }

    render() {
        const { protectionsPackages, purchaseMethodLabels, purchaseMethods } = this.props;
        const totalProtectionsAmount = purchaseMethods.getProtectionsAmount(protectionsPackages);
        const protectionsRenderBlock = protectionsPackages.map((protectionPackage) => {
            const label = protectionPackage.label || protectionPackage.description;
            const description =
                protectionPackage.label && protectionPackage.description ? ` (${protectionPackage.description})` : '';
            return (
                <AmountLineItemWithIcon
                    label={`${label}${description}`}
                    amount={protectionPackage.retail}
                    icon="plus"
                />
            );
        });

        return (
            <div>
                <div className="SidebarSummary__groupTitle">
                    <h3 className="sr-title SidebarSummary__groupTitle--title">
                        {LocaleService.t('SUMMARY.SUMMARY_PROTECTIONS_TITLE', { finance: purchaseMethodLabels.name })}
                        {!this.state.showProtectionsDetails && (
                            <span className="SidebarSummary__groupTitle--subtitle">
                                {LocaleService.t('SUMMARY.SELECTED_PROTECTIONS_AMOUNT', {
                                    amount: protectionsPackages.length,
                                })}
                            </span>
                        )}
                    </h3>
                    {protectionsPackages.length > 0 && (
                        <button className="sr-link" onClick={this.showProtectionsDetails}>
                            {!this.state.showProtectionsDetails
                                ? LocaleService.t('SUMMARY.SEE_DETAILS')
                                : LocaleService.t('SUMMARY.CLOSE_DETAILS')}
                        </button>
                    )}
                </div>
                <ReactCollapse isOpened={this.state.showProtectionsDetails}>
                    <ul className="protectionsListing">{protectionsRenderBlock}</ul>
                </ReactCollapse>
                <AmountLineItem label={LocaleService.t('SUMMARY.TOTAL')} amount={totalProtectionsAmount} />
            </div>
        );
    }
}

ProtectionsListing.defaultProps = {
    purchaseMethodLabels: [],
    protectionsPackages: [],
};

ProtectionsListing.propTypes = {
    purchaseMethodLabels: PropTypes.shape({
        name: PropTypes.string.isRequired,
    }),
    purchaseMethods: PropTypes.instanceOf(PurchaseMethodsModel),
    protectionsPackages: PropTypes.arrayOf(
        PropTypes.shape({
            items: PropTypes.arrayOf(PropTypes.instanceOf(ModelYear.OptionModel)),
            itemsPackage: PropTypes.instanceOf(ModelYear.OptionModel),
            payment: PropTypes.number.isRequired,
            paymentTaxes: PropTypes.number.isRequired,
            retail: PropTypes.number.isRequired,
            taxes: PropTypes.number.isRequired,
        })
    ),
};

ProtectionsListing.displayName = 'ProtectionsListing';

export default ProtectionsListing;



// WEBPACK FOOTER //
// ../widget-commons-vehicle/src/Quote/components/TransactionSummary/ProtectionsListing/ProtectionsListing.jsx